import React, { CSSProperties, SVGAttributes } from 'react';
import './Icons.scss';

export interface IconProps extends SVGAttributes<SVGElement> {
  className?: string;
  style?: CSSProperties;
  spin?: boolean;
  rotate?: number;
  onClick?: () => void;
}

interface IconContentProps {
  className?: string;
  style?: CSSProperties;
  spin?: boolean;
  rotate?: number;
  onClick?: () => void;
  iconName: string;
}

interface IconDetailProps {
  [name: string]: { viewBox: string; d: string };
}

const icons: IconDetailProps = {
  IconAngleDown: {
    viewBox: '0 0 320 512',
    d:
      'M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z',
  },
  IconArrowToTop: {
    viewBox: '64 64 896 896',
    d:
      'M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z',
  },
  IconBars: {
    viewBox: '0 0 448 512',
    d:
      'M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z',
  },
  IconCombination: {
    viewBox: '0 0 512 512',
    d:
      'M47 355.77V207.678h22.96v24.108h1.148c3.635-8.419 8.706-15.115 15.211-20.09 6.697-4.975 15.594-7.462 26.691-7.462 15.307 0 27.361 4.975 36.162 14.924 8.993 9.758 13.489 23.63 13.489 41.615v94.997h-22.96v-90.979c0-26.595-11.193-39.893-33.579-39.893-4.592 0-9.088.574-13.489 1.722-4.21 1.148-8.036 2.87-11.48 5.166-3.444 2.296-6.218 5.262-8.323 8.897-1.913 3.444-2.87 7.558-2.87 12.341V355.77H47zM283.017 359.214c-25.447 0-45.25-8.61-59.409-25.83-14.159-17.411-21.238-42.954-21.238-76.629 0-33.675 7.079-59.505 21.238-77.49C237.767 161.088 257.57 152 283.017 152c16.837 0 30.9 3.827 42.189 11.48 11.48 7.653 20.377 18.464 26.691 32.431l-19.516 11.767c-4.018-10.332-10.141-18.559-18.368-24.682-8.227-6.314-18.559-9.471-30.996-9.471-8.61 0-16.359 1.626-23.247 4.879-6.697 3.253-12.437 7.94-17.22 14.063-4.592 5.931-8.132 13.106-10.619 21.525-2.487 8.227-3.731 17.507-3.731 27.839v29.848c0 20.664 4.783 36.832 14.35 48.503s23.056 17.507 40.467 17.507c12.819 0 23.534-3.253 32.144-9.758 8.61-6.697 14.924-15.498 18.942-26.404l19.229 12.054c-6.314 14.159-15.402 25.352-27.265 33.579-11.863 8.036-26.213 12.054-43.05 12.054zM388.373 355.77V207.678h22.96v27.265h1.435c2.679-7.079 7.462-13.393 14.35-18.942 6.888-5.549 16.359-8.323 28.413-8.323h8.897v22.96h-13.489c-12.437 0-22.195 2.392-29.274 7.175-6.888 4.592-10.332 10.428-10.332 17.507v100.45h-22.96z',
  },
  IconCommentDots: {
    viewBox: '0 0 512 512',
    d:
      'M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z',
  },
  IconEye: {
    viewBox: '0 0 576 512',
    d:
      'M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z',
  },
  IconEnvelope: {
    viewBox: '0 0 448 512',
    d:
      'M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z',
  },
  IconEyeSlash: {
    viewBox: '0 0 640 512',
    d:
      'M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z',
  },
  IconGCD: {
    viewBox: '0 0 512 512',
    d:
      'M150.861 315.574h-.884c-1.621 7.514-6.041 13.776-13.26 18.785-7.072 4.862-16.501 7.293-28.288 7.293-9.135 0-17.606-1.694-25.415-5.083-7.809-3.536-14.586-8.619-20.332-15.249-5.599-6.777-10.019-15.102-13.26-24.973-3.094-10.019-4.641-21.511-4.641-34.476 0-12.818 1.62-24.163 4.862-34.034 3.241-10.019 7.809-18.417 13.702-25.194 5.893-6.777 12.965-11.86 21.216-15.249 8.25-3.536 17.459-5.304 27.625-5.304 13.849 0 25.562 3.094 35.139 9.282 9.577 6.041 17.017 14.512 22.321 25.415l-20.332 11.934c-2.947-7.219-7.514-13.039-13.702-17.459-6.188-4.567-13.997-6.851-23.426-6.851-12.229 0-22.1 3.904-29.614 11.713-7.367 7.809-11.05 18.859-11.05 33.15v25.194c0 14.291 3.683 25.341 11.05 33.15 7.514 7.809 17.385 11.713 29.614 11.713 4.862 0 9.503-.589 13.923-1.768 4.42-1.326 8.251-3.168 11.492-5.525 3.389-2.505 6.041-5.525 7.956-9.061 2.063-3.683 3.094-7.956 3.094-12.818v-11.934h-31.824v-21.437h55.913V339h-21.879v-23.426zM265.356 341.652c-20.184 0-36.023-6.777-47.515-20.332-11.492-13.702-17.238-33.518-17.238-59.449 0-12.965 1.474-24.384 4.42-34.255 2.947-9.871 7.22-18.196 12.818-24.973 5.599-6.777 12.376-11.86 20.332-15.249 8.104-3.536 17.165-5.304 27.183-5.304 13.408 0 24.605 2.947 33.592 8.84 9.135 5.893 16.281 14.586 21.437 26.078L299.39 228.5c-2.652-7.367-6.777-13.186-12.376-17.459-5.451-4.42-12.67-6.63-21.658-6.63-11.934 0-21.289 4.052-28.067 12.155-6.777 8.103-10.166 19.301-10.166 33.592v23.426c0 14.291 3.389 25.489 10.166 33.592 6.778 8.103 16.133 12.155 28.067 12.155 9.282 0 16.796-2.357 22.542-7.072 5.894-4.862 10.24-11.05 13.039-18.564l20.111 12.155c-5.156 11.197-12.376 19.964-21.658 26.299-9.282 6.335-20.626 9.503-34.034 9.503zM347.522 184.742h54.587c9.871 0 18.785 1.621 26.741 4.862 8.103 3.241 14.954 8.103 20.553 14.586 5.746 6.335 10.166 14.365 13.26 24.089 3.094 9.577 4.641 20.774 4.641 33.592 0 12.818-1.547 24.089-4.641 33.813-3.094 9.577-7.514 17.606-13.26 24.089-5.599 6.335-12.45 11.124-20.553 14.365-7.956 3.241-16.87 4.862-26.741 4.862h-54.587V184.742zM402.109 316.9c11.492 0 20.774-3.61 27.846-10.829 7.072-7.219 10.608-17.827 10.608-31.824v-24.752c0-13.997-3.536-24.605-10.608-31.824-7.072-7.219-16.354-10.829-27.846-10.829h-29.614V316.9h29.614z',
  },
  IconGithub: {
    viewBox: '0 0 448 512',
    d:
      'M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z',
  },
  IconHome: {
    viewBox: '64 64 896 896',
    d:
      'M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z',
  },
  IconLaptopCode: {
    viewBox: '0 0 640 512',
    d:
      'M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z',
  },
  IconLCM: {
    viewBox: '0 0 512 512',
    d:
      'M62.1 339V184.742h24.972V316.9h62.764V339H62.099zM225.753 341.652c-20.184 0-36.023-6.777-47.515-20.332C166.746 307.618 161 287.802 161 261.871c0-12.965 1.474-24.384 4.42-34.255 2.947-9.871 7.22-18.196 12.818-24.973 5.599-6.777 12.376-11.86 20.332-15.249 8.104-3.536 17.165-5.304 27.183-5.304 13.408 0 24.605 2.947 33.592 8.84 9.135 5.893 16.281 14.586 21.437 26.078L259.787 228.5c-2.652-7.367-6.777-13.186-12.376-17.459-5.451-4.42-12.67-6.63-21.658-6.63-11.934 0-21.289 4.052-28.067 12.155-6.777 8.103-10.166 19.301-10.166 33.592v23.426c0 14.291 3.389 25.489 10.166 33.592 6.778 8.103 16.133 12.155 28.067 12.155 9.282 0 16.796-2.357 22.542-7.072 5.894-4.862 10.24-11.05 13.039-18.564l20.111 12.155c-5.156 11.197-12.376 19.964-21.658 26.299-9.282 6.335-20.626 9.503-34.034 9.503zM425.933 220.986h-1.105l-12.155 24.973-33.813 61.659-33.813-61.659-12.155-24.973h-1.105V339h-23.868V184.742h29.614l41.327 78.455h1.326l41.327-78.455h28.288V339h-23.868V220.986z',
  },
  IconLink: {
    viewBox: '0 0 512 512',
    d:
      'M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z',
  },
  IconLinkedIn: {
    viewBox: '0 0 448 512',
    d:
      'M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z',
  },
  IconLogo: {
    viewBox: '0 0 512 512',
    d:
      'M472.929 396.064c3.905 3.905 3.907 10.263-.142 14.019-102.927 95.484-263.807 93.168-363.922-6.948C8.749 303.02 6.433 142.14 101.917 39.213c3.756-4.049 10.113-4.047 14.019-.142l32.249 32.25c3.906 3.905 3.884 10.221.179 14.317-69.899 77.261-67.601 196.612 6.893 271.105 74.493 74.494 193.844 76.792 271.105 6.893 4.096-3.705 10.412-3.727 14.317.178l32.25 32.25z M416.925 82.239c7.435-1.993 14.24 4.812 12.247 12.247l-49.857 186.069c-1.992 7.435-11.287 9.926-16.73 4.482L226.374 148.826c-5.444-5.443-2.953-14.738 4.482-16.73l186.069-49.857z',
  },
  IconObjectGroup: {
    viewBox: '0 0 512 512',
    d:
      'M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z',
  },
  IconPermutation: {
    viewBox: '0 0 448 512',
    d:
      'M50 356.024V207.416h23.04v24.192h1.152c3.648-8.448 8.736-15.168 15.264-20.16 6.72-4.992 15.648-7.488 26.784-7.488 15.36 0 27.456 4.992 36.288 14.976 9.024 9.792 13.536 23.712 13.536 41.76v95.328h-23.04v-91.296c0-26.688-11.232-40.032-33.696-40.032-4.608 0-9.12.576-13.536 1.728-4.224 1.152-8.064 2.88-11.52 5.184-3.456 2.304-6.24 5.28-8.352 8.928-1.92 3.456-2.88 7.584-2.88 12.384v103.104H50zM215.992 356.024V155h80.064c18.048 0 31.872 5.184 41.472 15.552 9.792 10.176 14.688 24.192 14.688 42.048s-4.896 31.968-14.688 42.336c-9.6 10.176-23.424 15.264-41.472 15.264h-55.872v85.824h-24.192zm24.192-107.136h55.872c9.6 0 16.992-2.496 22.176-7.488 5.376-4.992 8.064-12.096 8.064-21.312v-14.976c0-9.216-2.688-16.32-8.064-21.312-5.184-4.992-12.576-7.488-22.176-7.488h-55.872v72.576zM385.531 356.024V207.416h23.04v27.36h1.44c2.688-7.104 7.488-13.44 14.4-19.008s16.416-8.352 28.512-8.352h8.928v23.04h-13.536c-12.48 0-22.272 2.4-29.376 7.2-6.912 4.608-10.368 10.464-10.368 17.568v100.8h-23.04z',
  },
  IconPlay: {
    viewBox: '0 0 448 512',
    d:
      'M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z',
  },
  IconQueue: {
    viewBox: '0 0 512 512',
    d:
      'M416 448V64h32v384h-32zM64 448V64h32v384H64zM128 336h256v94.995L128 432v-96zM128 208h256v94.995L128 304v-96zM128 80h256v94.995L128 176V80z',
  },
  IconRss: {
    viewBox: '0 0 448 512',
    d:
      'M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z',
  },
  IconSearch: {
    viewBox: '0 0 512 512',
    d:
      'M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z',
  },
  IconSearchPlus: {
    viewBox: '0 0 512 512',
    d:
      'M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z',
  },
  IconSieve: {
    viewBox: '0 0 512 512',
    d:
      'M428.059 113.778h-51.991c-3.046-13.56-14.685-23.908-28.881-24.99-1.265-16.565-15.151-29.658-32.039-29.658-2.456 0-4.916.286-7.311.851a7.499 7.499 0 00-5.58 9.02c.95 4.032 4.994 6.532 9.02 5.58 1.27-.299 2.571-.45 3.871-.45 9.447 0 17.133 7.683 17.133 17.125 0 1.296-.151 2.599-.451 3.872a7.5 7.5 0 009.016 9.018 16.974 16.974 0 013.876-.45c6.935 0 12.906 4.147 15.601 10.084H151.679c2.694-5.937 8.666-10.084 15.601-10.084 1.299 0 2.603.151 3.876.45a7.5 7.5 0 009.016-9.018 16.904 16.904 0 01-.451-3.872c0-9.442 7.686-17.125 17.133-17.125 1.3 0 2.602.151 3.871.45a7.499 7.499 0 009.02-9.016 16.981 16.981 0 01-.451-3.873c0-9.443 7.686-17.126 17.133-17.126 1.297 0 2.601.152 3.875.451a7.498 7.498 0 009.016-9.02 16.9 16.9 0 01-.45-3.869C238.866 22.684 246.553 15 256 15s17.134 7.684 17.134 17.127c0 1.298-.151 2.6-.45 3.869a7.497 7.497 0 009.016 9.02 17.025 17.025 0 0113.9 2.798 7.5 7.5 0 0010.474-1.673 7.499 7.499 0 00-1.673-10.474 32.29 32.29 0 00-5.217-3.078 31.754 31.754 0 00-11.144-2.932C286.775 13.092 272.888 0 256 0s-30.775 13.093-32.04 29.659c-15.756 1.201-28.37 13.813-29.573 29.564-15.756 1.201-28.37 13.813-29.573 29.564-14.196 1.082-25.835 11.431-28.881 24.99H83.941c-6.893 0-12.5 5.607-12.5 12.5v20.21c0 6.893 5.607 12.5 12.5 12.5h5.817c6.407 36.678 24.823 70.264 52.663 95.602A169.112 169.112 0 00166.11 272.6a7.445 7.445 0 002.317 1.435c26.207 15.925 56.398 24.478 87.571 24.478 42.119 0 82.455-15.599 113.578-43.923 27.84-25.338 46.256-58.924 52.663-95.602h5.817c6.893 0 12.5-5.607 12.5-12.5v-20.21c.003-6.892-5.605-12.5-12.497-12.5zM112.09 184.05a151.413 151.413 0 01-1.782-4.972l3.378 3.377-1.596 1.595zm264.505-1.595l-11.302 11.297-11.301-11.297 11.301-11.299 11.302 11.299zm-.694-21.903l1.563-1.563h22.604l-12.865 12.861-11.302-11.298zm-185.88 54.41l11.302 11.298-11.302 11.298-11.301-11.298 11.301-11.298zm-21.91.692l-11.301-11.297 11.301-11.298 11.301 11.298-11.301 11.297zm32.518-11.297l11.301-11.299 11.302 11.299-11.302 11.298-11.301-11.298zm33.21 10.605l11.302 11.298-11.302 11.298-11.301-11.298 11.301-11.298zm10.608-10.605l11.301-11.298 11.301 11.298-11.301 11.297-11.301-11.297zm11.301 32.507l11.301 11.298-11.301 11.298-11.301-11.298 11.301-11.298zm10.608-10.604l11.301-11.298 11.301 11.298-11.301 11.297-11.301-11.297zm21.91-21.903l11.301-11.298 11.301 11.298-11.301 11.297-11.301-11.297zm33.21 10.605l11.301 11.298-11.301 11.298-11.302-11.298 11.302-11.298zm10.607-10.605l11.302-11.298 11.301 11.298-11.301 11.298-11.302-11.298zm11.302-32.507l-11.302-11.298 1.563-1.563h19.475l1.564 1.563-11.3 11.298zm-10.609 10.605l-11.301 11.297-11.302-11.298 11.302-11.298 11.301 11.299zm-33.21-10.605l-11.301-11.298 1.564-1.563h19.474l1.563 1.563-11.3 11.298zm-10.608 10.604l-11.301 11.298-11.301-11.298 11.301-11.298 11.301 11.298zm-33.21-10.604l-11.302-11.299 1.563-1.563h19.475l1.564 1.563-11.3 11.299zm-10.607 10.604l-11.302 11.298-11.302-11.298 11.302-11.298 11.302 11.298zM211.93 171.85l-11.301-11.298 1.564-1.563h19.475l1.563 1.563-11.301 11.298zm-10.609 10.604l-11.301 11.298-11.301-11.297 11.301-11.298 11.301 11.297zm-33.21-10.604l-11.301-11.298 1.564-1.563h19.475l1.563 1.563-11.301 11.298zm-10.607 10.605l-11.301 11.297-11.302-11.297 11.302-11.299 11.301 11.299zm-33.21-10.605l-12.866-12.861h22.604l1.563 1.563-11.301 11.298zm2.493 41.312a153.37 153.37 0 01-8.229-14.369l5.735-5.733 11.301 11.298-8.807 8.804zm8.878 12.335l10.538-10.535 11.301 11.298-11.225 11.221a154.532 154.532 0 01-10.614-11.984zm34.539 31.871a153.79 153.79 0 01-12.898-9.701l10.806-10.803 11.302 11.298-9.21 9.206zm28.657 15.157a152.807 152.807 0 01-15.417-7.184l6.576-6.574 11.302 11.298-2.461 2.46zm1.768-24.363l11.301-11.297 11.301 11.297-11.301 11.298-11.301-11.298zm33.21 33.2l-11.301-11.297 11.301-11.298 11.301 11.297-11.301 11.298zM256 283.513c-1.021 0-2.041-.016-3.061-.035l2.809-2.808 2.814 2.813c-.853.014-1.707.03-2.562.03zm21.657-2.15l-11.302-11.299 11.302-11.298 11.301 11.298-11.301 11.299zm10.609-33.201l11.301-11.298 11.301 11.298-11.301 11.298-11.301-11.298zm24.513 24.507l-2.605-2.604 11.302-11.297 6.753 6.751a153.183 153.183 0 01-15.45 7.15zm28.715-15.099l-9.411-9.408 11.302-11.298 11.037 11.034a153.83 153.83 0 01-12.928 9.672zm23.977-19.836l-11.479-11.475 11.301-11.298 10.818 10.815a154.565 154.565 0 01-10.64 11.958zm19.546-24.264l-9.115-9.112 11.301-11.298 6.071 6.069a153.727 153.727 0 01-8.257 14.341zm14.756-29.053l-1.963-1.962 4.133-4.132a151.49 151.49 0 01-2.17 6.094zm25.786-40.429H86.441v-15.21h339.117v15.21z M237.127 70.652c3.066-3.064 8.055-3.064 11.121 0a7.474 7.474 0 005.303 2.196 7.5 7.5 0 005.303-12.803c-8.914-8.912-23.418-8.912-32.332 0a7.5 7.5 0 00-.001 10.606 7.5 7.5 0 0010.606.001zM274.301 88.785a7.5 7.5 0 0010.606 10.607c3.067-3.065 8.055-3.063 11.12 0a7.474 7.474 0 005.303 2.196c1.919 0 3.84-.732 5.304-2.197a7.498 7.498 0 00-.001-10.606c-8.914-8.911-23.417-8.913-32.332 0zM196.737 93.276a7.5 7.5 0 0010.606 10.607c3.065-3.063 8.053-3.065 11.12 0a7.474 7.474 0 005.303 2.196c1.919 0 3.84-.732 5.304-2.197a7.498 7.498 0 00-.001-10.606c-8.915-8.912-23.418-8.91-32.332 0zM433.97 497h-55.548l-44.271-41.819a7.5 7.5 0 10-10.301 10.905L356.578 497H153.441l59.965-60.221c10.543-10.587 24.646-16.418 39.711-16.418 15.066 0 29.171 5.831 39.714 16.419l8.021 7.58a7.5 7.5 0 0010.602-.304 7.5 7.5 0 00-.303-10.603l-7.773-7.341c-13.369-13.383-31.214-20.752-50.26-20.752-19.083 0-36.961 7.398-50.34 20.834L132.273 497H78.03c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h355.94c4.143 0 7.5-3.357 7.5-7.5s-3.358-7.5-7.5-7.5z M259.399 431.92a7.552 7.552 0 00-2.199 5.31c0 1.971.8 3.9 2.199 5.301a7.516 7.516 0 005.301 2.199c1.979 0 3.909-.8 5.3-2.199a7.55 7.55 0 002.2-5.301c0-1.979-.801-3.91-2.2-5.31a7.562 7.562 0 00-5.3-2.19 7.559 7.559 0 00-5.301 2.19zM295.35 455.63c0-1.97-.8-3.91-2.2-5.311a7.576 7.576 0 00-5.3-2.189c-1.98 0-3.91.8-5.31 2.189a7.58 7.58 0 00-2.19 5.311c0 1.97.8 3.91 2.19 5.3a7.55 7.55 0 005.31 2.2c1.97 0 3.9-.8 5.3-2.2 1.4-1.4 2.2-3.33 2.2-5.3zM305.69 464.85a7.55 7.55 0 00-2.199 5.311c0 1.97.8 3.899 2.199 5.3a7.55 7.55 0 005.301 2.2 7.559 7.559 0 005.31-2.2 7.578 7.578 0 002.19-5.3c0-1.98-.801-3.91-2.19-5.311a7.583 7.583 0 00-5.31-2.189 7.574 7.574 0 00-5.301 2.189zM243.96 450.319a7.581 7.581 0 00-2.191 5.311c0 1.97.8 3.91 2.191 5.3a7.549 7.549 0 005.309 2.2c1.971 0 3.9-.8 5.3-2.2a7.543 7.543 0 002.2-5.3c0-1.97-.8-3.91-2.2-5.311a7.574 7.574 0 00-5.3-2.189c-1.979 0-3.91.8-5.309 2.189zM280.67 473.96c-1.97 0-3.9.81-5.3 2.2a7.543 7.543 0 00-2.2 5.3c0 1.98.8 3.91 2.2 5.31a7.582 7.582 0 005.3 2.2c1.98 0 3.91-.81 5.31-2.2a7.578 7.578 0 002.19-5.31c0-1.97-.8-3.9-2.19-5.3a7.596 7.596 0 00-5.31-2.2zM178.67 301.819a7.585 7.585 0 00-2.19 5.311c0 1.97.801 3.9 2.19 5.3a7.592 7.592 0 005.31 2.2c1.971 0 3.9-.811 5.301-2.2a7.547 7.547 0 002.199-5.3c0-1.98-.8-3.91-2.199-5.311a7.578 7.578 0 00-5.301-2.189c-1.98 0-3.911.8-5.31 2.189zM322.72 301.819a7.594 7.594 0 00-2.2 5.311c0 1.97.811 3.9 2.2 5.3a7.57 7.57 0 005.3 2.2c1.98 0 3.91-.811 5.311-2.2a7.576 7.576 0 002.189-5.3c0-1.98-.8-3.91-2.189-5.311a7.584 7.584 0 00-5.311-2.189c-1.97 0-3.911.8-5.3 2.189zM222.99 315.92a7.556 7.556 0 00-2.19 5.3c0 1.98.8 3.91 2.19 5.311a7.6 7.6 0 005.31 2.189c1.97 0 3.9-.8 5.3-2.189 1.4-1.4 2.2-3.341 2.2-5.311 0-1.97-.8-3.9-2.2-5.3a7.543 7.543 0 00-5.3-2.2c-1.97 0-3.91.8-5.31 2.2zM285.71 313.72c-1.97 0-3.9.8-5.3 2.2a7.582 7.582 0 00-2.2 5.3c0 1.97.81 3.91 2.2 5.311a7.576 7.576 0 005.3 2.189c1.98 0 3.91-.8 5.31-2.189a7.58 7.58 0 002.19-5.311c0-1.97-.8-3.91-2.19-5.3a7.55 7.55 0 00-5.31-2.2zM261.3 351.7c1.4-1.4 2.2-3.33 2.2-5.301 0-1.98-.8-3.909-2.2-5.31a7.56 7.56 0 00-5.3-2.19c-1.98 0-3.91.801-5.3 2.19a7.55 7.55 0 00-2.2 5.31c0 1.971.8 3.91 2.2 5.301 1.39 1.399 3.33 2.199 5.3 2.199s3.899-.799 5.3-2.199zM299.31 363.97c1.98 0 3.91-.8 5.31-2.2a7.56 7.56 0 002.19-5.3c0-1.979-.8-3.91-2.19-5.3a7.55 7.55 0 00-5.31-2.2c-1.97 0-3.899.8-5.3 2.2a7.51 7.51 0 00-2.2 5.3c0 1.97.8 3.91 2.2 5.3 1.4 1.4 3.33 2.2 5.3 2.2zM241.63 380.37a7.508 7.508 0 00-2.2 5.3 7.51 7.51 0 007.5 7.5c1.98 0 3.91-.8 5.311-2.2a7.542 7.542 0 002.189-5.3c0-1.97-.8-3.91-2.189-5.3-1.4-1.4-3.33-2.2-5.311-2.2-1.97 0-3.91.8-5.3 2.2zM198.319 356.2a7.552 7.552 0 00-2.199 5.31c0 1.97.8 3.9 2.199 5.3a7.559 7.559 0 005.301 2.19c1.97 0 3.91-.8 5.3-2.19a7.548 7.548 0 002.2-5.3c0-1.979-.801-3.91-2.2-5.31a7.51 7.51 0 00-5.3-2.2c-1.98 0-3.91.8-5.301 2.2z',
  },
  IconSpinner: {
    viewBox: '0 0 1024 1024',
    d:
      'M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z',
  },
  IconTimes: {
    viewBox: '0 0 352 512',
    d:
      'M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z',
  },
  IconTimesCircle: {
    viewBox: '0 0 512 512',
    d:
      'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z',
  },
  IconNode: {
    viewBox: '0 0 512 512',
    d:
      'M421.75 368.7c-6.2-37.6-39.6-64.55-77.65-62.7-38.05 1.85-68.65 32-71.1 70-76.75-2.4-104-20.35-99.55-56.85 1.65-13.65 9.9-20.95 25.05-24.5 9.2-2.15 19.4-2.45 28.65-1.6.85.1 1.75.15 2.6.25 5.65 1.35 11.4 2.5 17.15 3.4 17.05 2.8 34.4 4.2 50.9 3.3 46.4-2.5 78-22.95 79.6-66.35 1.55-42.05-27.35-71.85-73.95-91.8-14.95-6.4-30.8-11.35-46.65-15.1-7.15-1.7-13.15-2.85-17.6-3.6-3.95-37.95-35.75-66.9-73.9-67.2-38.15-.3-70.45 28.05-75.05 65.95-4.6 37.9 20 73.15 57.1 81.95 37.1 8.8 74.95-11.65 87.85-47.55 4.7.85 9.35 1.8 14 2.9 14.1 3.3 28.2 7.7 41.2 13.3 35.35 15.1 54.65 35.05 53.75 59.95-.8 22.3-16.8 32.6-48.1 34.3-13.75.75-28.8-.45-43.65-2.9-4.15-.7-7.95-1.4-11.3-2.15-1.95-.4-3.3-.75-3.9-.9l-1.55-.3c-1.1-.15-2.95-.4-5.35-.65-12.5-1.15-26.05-.75-39.25 2.3-27.6 6.45-46.95 23.6-50.55 52.9-7.85 63.1 39.3 92.35 138 94.45 14.55 35.2 53.2 53.95 89.8 43.5 36.65-10.45 59.65-46.7 53.45-84.3zm-257.2-196.1c-23 0-41.65-18.65-41.65-41.65s18.65-41.65 41.65-41.65 41.65 18.65 41.65 41.65-18.65 41.65-41.65 41.65zM347.8 422.5c-23 0-41.65-18.65-41.65-41.65s18.65-41.65 41.65-41.65 41.65 18.65 41.65 41.65-18.65 41.65-41.65 41.65z',
  },
  IconUser: {
    viewBox: '0 0 448 512',
    d:
      'M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z',
  },
  IconUserTie: {
    viewBox: '0 0 448 512',
    d:
      'M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z',
  },
  IconWaveLine: {
    viewBox: '0 0 512 512',
    d:
      'M130 226l-64 40.5V286l64-35 62.5 35 64.5-35 63 35 65-35 42 31 19.5-15.5L385 226l-65 40.5-63-40.5-64.5 40.5L130 226z',
  },
};

const getRotateDegree = (viewBox: string) => {
  const viewBoxArray = viewBox.split(' ');

  return `${+viewBoxArray[2] / 2} ${+viewBoxArray[3] / 2}`;
};

const IconTemplate = ({
  className,
  style,
  spin,
  rotate,
  onClick,
  iconName,
}: IconContentProps): React.ReactElement => {
  return (
    <svg
      viewBox={icons[iconName].viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path
        transform={
          rotate
            ? `rotate(${rotate} ${getRotateDegree(icons[iconName].viewBox)})`
            : undefined
        }
        d={icons[iconName].d}
      />
    </svg>
  );
};

const IconAngleDown = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconAngleDown';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconArrowToTop = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconArrowToTop';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconBars = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconBars';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconCombination = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconCombination';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconCommentDots = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconCommentDots';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconEye = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconEye';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconEnvelope = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconEnvelope';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconEyeSlash = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconEyeSlash';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconGithub = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconGithub';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconGCD = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconGCD';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconHome = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconHome';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconLaptopCode = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconLaptopCode';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconLCM = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconLCM';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconLink = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconLink';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconLinkedIn = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconLinkedIn';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconLogo = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconLogo';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconObjectGroup = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconObjectGroup';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconPermutation = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconPermutation';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconPlay = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconPlay';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconSearch = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconSearch';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconSearchPlus = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconSearchPlus';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconSieve = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconSieve';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconSpinner = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconSpinner';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconTimes = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconTimes';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconTimesCircle = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconTimesCircle';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconUser = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconUser';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconUserTie = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconUserTie';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconLogoColored = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 512 512';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path
        transform={
          rotate ? `rotate(${rotate} ${getRotateDegree(viewBox)})` : undefined
        }
        fill="#614CF6"
        d="M472.929 396.064c3.905 3.905 3.907 10.263-.142 14.019-102.927 95.484-263.807 93.168-363.922-6.948C8.749 303.02 6.433 142.14 101.917 39.213c3.756-4.049 10.113-4.047 14.019-.142l32.249 32.25c3.906 3.905 3.884 10.221.179 14.317-69.899 77.261-67.601 196.612 6.893 271.105 74.493 74.494 193.844 76.792 271.105 6.893 4.096-3.705 10.412-3.727 14.317.178l32.25 32.25z"
      />
      <path
        transform={
          rotate ? `rotate(${rotate} ${getRotateDegree(viewBox)})` : undefined
        }
        fill="#F6A54C"
        d="M416.925 82.239c7.435-1.993 14.24 4.812 12.247 12.247l-49.857 186.069c-1.992 7.435-11.287 9.926-16.73 4.482L226.374 148.826c-5.444-5.443-2.953-14.738 4.482-16.73l186.069-49.857z"
      />
    </svg>
  );
};

const IconAWS = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '14.7 23 42 26.2';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path fill="#F7981F" d="M27.09 35.764l-1.106 4.576h2.198l-1.067-4.576z" />
      <path fill="#F7981F" d="M16.302 40.744v.666c0 3.311 3.579 6.66 7.991 6.66h23.533c4.412 0 7.991-3.35 7.991-6.66v-.666c0-3.078-3.098-6.943-7.081-7.283a5.118 5.118 0 00-8.011-4.055c-1.58-3.52-5.107-5.977-9.216-5.977-5.579 0-10.101 4.521-10.101 10.102 0 .1.012.195.015.293-2.993.867-5.121 4.371-5.121 6.92zm12.699 3.055l-.572-2.275h-2.717l-.599 2.275h-1.547l2.639-9.283h1.898l2.444 9.283h-1.546zm9.012 0h-1.716l-1.196-6.994h-.026l-1.183 6.994h-1.716l-1.795-9.283h1.496l1.221 7.215h.027l1.221-7.215h1.561l1.248 7.254h.026l1.209-7.254h1.469l-1.846 9.283zm5.433.181c-2.301 0-2.821-1.533-2.821-2.834v-.221h1.482v.234c0 1.131.494 1.703 1.521 1.703.936 0 1.403-.664 1.403-1.354 0-.975-.493-1.404-1.325-1.65l-1.015-.352c-1.353-.52-1.937-1.221-1.937-2.547 0-1.691 1.144-2.627 2.886-2.627 2.379 0 2.626 1.482 2.626 2.443v.209h-1.482v-.195c0-.846-.377-1.34-1.3-1.34-.637 0-1.248.352-1.248 1.34 0 .793.403 1.195 1.392 1.572l1 .365c1.313.467 1.886 1.184 1.886 2.457.001 1.979-1.196 2.797-3.068 2.797z" />
      <path fill="#fff" d="M26.205 34.516l-2.639 9.283h1.547l.599-2.275h2.717l.572 2.275h1.547l-2.444-9.283h-1.899zm-.221 5.824l1.105-4.576h.025l1.066 4.576h-2.196zM37.181 41.77h-.027l-1.248-7.254h-1.56l-1.221 7.214h-.027l-1.221-7.214h-1.496l1.795 9.283h1.716l1.182-6.994h.027l1.196 6.994h1.716l1.845-9.283H38.39zM44.629 38.729l-1-.365c-.988-.377-1.392-.779-1.392-1.572 0-.988.611-1.34 1.248-1.34.923 0 1.3.494 1.3 1.34v.195h1.482v-.209c0-.961-.247-2.443-2.626-2.443-1.742 0-2.886.936-2.886 2.627 0 1.326.584 2.027 1.937 2.547l1.015.352c.832.246 1.325.676 1.325 1.65 0 .689-.468 1.354-1.403 1.354-1.027 0-1.521-.572-1.521-1.703v-.234h-1.482v.221c0 1.301.521 2.834 2.821 2.834 1.872 0 3.068-.818 3.068-2.795 0-1.276-.573-1.993-1.886-2.459z" />
    </svg>
  );
};

const IconCSS3 = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 128 128';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path fill="#1572B6" d="M18.814 114.123L8.76 1.352h110.48l-10.064 112.754-45.243 12.543-45.119-12.526z" />
      <path fill="#33A9DC" d="M64.001 117.062l36.559-10.136 8.601-96.354h-45.16v106.49z" />
      <path fill="#fff" d="M64.001 51.429h18.302l1.264-14.163H64.001V23.435h34.682l-.332 3.711-3.4 38.114h-30.95V51.429z" />
      <path fill="#EBEBEB" d="M64.083 87.349l-.061.018-15.403-4.159-.985-11.031H33.752l1.937 21.717 28.331 7.863.063-.018v-14.39z" />
      <path fill="#fff" d="M81.127 64.675l-1.666 18.522-15.426 4.164v14.39l28.354-7.858.208-2.337 2.406-26.881H81.127z" />
      <path fill="#EBEBEB" d="M64.048 23.435v13.831H30.64l-.277-3.108-.63-7.012-.331-3.711h34.646zm-.047 27.996v13.831H48.792l-.277-3.108-.631-7.012-.33-3.711h16.447z" />
    </svg>
  );
};

const IconFigma = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 200 300';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path fill="#0acf83" d="M50 300c27.6 0 50-22.4 50-50v-50H50c-27.6 0-50 22.4-50 50s22.4 50 50 50z" />
      <path fill="#a259ff" d="M0 150c0-27.6 22.4-50 50-50h50v100H50c-27.6 0-50-22.4-50-50z" />
      <path fill="#f24e1e" d="M0 50C0 22.4 22.4 0 50 0h50v100H50C22.4 100 0 77.6 0 50z" />
      <path fill="#ff7262" d="M100 0h50c27.6 0 50 22.4 50 50s-22.4 50-50 50h-50V0z" />
      <path fill="#1abcfe" d="M200 150c0 27.6-22.4 50-50 50s-50-22.4-50-50 22.4-50 50-50 50 22.4 50 50z" />
    </svg>
  );
};

const IconGatsby = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 2500 2500';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path fill="#744c9e" d="M1250 0C559.6 0 0 559.6 0 1250s559.6 1250 1250 1250 1250-559.6 1250-1250S1940.4 0 1250 0zM268.6 1263l968.4 968.4c-531.8-6.9-961.5-436.6-968.4-968.4zm1201.1 943.9L293.1 1030.3C392.9 594 783.4 268.4 1250 268.4c326.1 0 615.1 159.1 793.6 403.9l-135.9 119.9c-144.8-207.6-385.4-343.5-657.7-343.5-346.7 0-642 220.2-753.6 528.4l1026.5 1026.4c249.3-90.3 441-300.7 505.2-561.3h-425.4V1250h629c-.1 466.6-325.7 857.1-762 956.9z" />
    </svg>
  );
};

const IconGraphql = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 400 400';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path fill="#E535AB" d="M57.468 302.66l-14.376-8.3 160.15-277.38 14.376 8.3z" />
      <path fill="#E535AB" d="M39.8 272.2h320.3v16.6H39.8z" />
      <path fill="#E535AB" d="M206.348 374.026l-160.21-92.5 8.3-14.376 160.21 92.5zM345.522 132.947l-160.21-92.5 8.3-14.376 160.21 92.5z" />
      <path fill="#E535AB" d="M54.482 132.883l-8.3-14.375 160.21-92.5 8.3 14.376z" />
      <path fill="#E535AB" d="M342.568 302.663l-160.15-277.38 14.376-8.3 160.15 277.38zM52.5 107.5h16.6v185H52.5z" />
      <path fill="#E535AB" d="M330.9 107.5h16.6v185h-16.6z" />
      <path fill="#E535AB" d="M203.522 367l-7.25-12.558 139.34-80.45 7.25 12.557z" />
      <path fill="#E535AB" d="M369.5 297.9c-9.6 16.7-31 22.4-47.7 12.8-16.7-9.6-22.4-31-12.8-47.7 9.6-16.7 31-22.4 47.7-12.8 16.8 9.7 22.5 31 12.8 47.7M90.9 137c-9.6 16.7-31 22.4-47.7 12.8-16.7-9.6-22.4-31-12.8-47.7 9.6-16.7 31-22.4 47.7-12.8 16.7 9.7 22.4 31 12.8 47.7M30.5 297.9c-9.6-16.7-3.9-38 12.8-47.7 16.7-9.6 38-3.9 47.7 12.8 9.6 16.7 3.9 38-12.8 47.7-16.8 9.6-38.1 3.9-47.7-12.8M309.1 137c-9.6-16.7-3.9-38 12.8-47.7 16.7-9.6 38-3.9 47.7 12.8 9.6 16.7 3.9 38-12.8 47.7-16.7 9.6-38.1 3.9-47.7-12.8M200 395.8c-19.3 0-34.9-15.6-34.9-34.9 0-19.3 15.6-34.9 34.9-34.9 19.3 0 34.9 15.6 34.9 34.9 0 19.2-15.6 34.9-34.9 34.9M200 74c-19.3 0-34.9-15.6-34.9-34.9 0-19.3 15.6-34.9 34.9-34.9 19.3 0 34.9 15.6 34.9 34.9 0 19.3-15.6 34.9-34.9 34.9" />
    </svg>
  );
};

const IconHtml5 = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 128 128';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path fill="#E44D26" d="M19.037 113.876L9.032 1.661h109.936l-10.016 112.198-45.019 12.48z" />
      <path fill="#F16529" d="M64 116.8l36.378-10.086 8.559-95.878H64z" />
      <path fill="#EBEBEB" d="M64 52.455H45.788L44.53 38.361H64V24.599H29.489l.33 3.692 3.382 37.927H64zm0 35.743l-.061.017-15.327-4.14-.979-10.975H33.816l1.928 21.609 28.193 7.826.063-.017z" />
      <path fill="#fff" d="M63.952 52.455v13.763h16.947l-1.597 17.849-15.35 4.143v14.319l28.215-7.82.207-2.325 3.234-36.233.335-3.696h-3.708zm0-27.856v13.762h33.244l.276-3.092.628-6.978.329-3.692z" />
    </svg>
  );
};

const IconJavascript = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 128 128';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path fill="#f7df1e" d="M1.408 1.408h125.184v125.185H1.408z" />
      <path d="M116.347 96.736c-.917-5.711-4.641-10.508-15.672-14.981-3.832-1.761-8.104-3.022-9.377-5.926-.452-1.69-.512-2.642-.226-3.665.821-3.32 4.784-4.355 7.925-3.403 2.023.678 3.938 2.237 5.093 4.724 5.402-3.498 5.391-3.475 9.163-5.879-1.381-2.141-2.118-3.129-3.022-4.045-3.249-3.629-7.676-5.498-14.756-5.355l-3.688.477c-3.534.893-6.902 2.748-8.877 5.235-5.926 6.724-4.236 18.492 2.975 23.335 7.104 5.332 17.54 6.545 18.873 11.531 1.297 6.104-4.486 8.08-10.234 7.378-4.236-.881-6.592-3.034-9.139-6.949-4.688 2.713-4.688 2.713-9.508 5.485 1.143 2.499 2.344 3.63 4.26 5.795 9.068 9.198 31.76 8.746 35.83-5.176.165-.478 1.261-3.666.38-8.581zM69.462 58.943H57.753l-.048 30.272c0 6.438.333 12.34-.714 14.149-1.713 3.558-6.152 3.117-8.175 2.427-2.059-1.012-3.106-2.451-4.319-4.485-.333-.584-.583-1.036-.667-1.071l-9.52 5.83c1.583 3.249 3.915 6.069 6.902 7.901 4.462 2.678 10.459 3.499 16.731 2.059 4.082-1.189 7.604-3.652 9.448-7.401 2.666-4.915 2.094-10.864 2.07-17.444.06-10.735.001-21.468.001-32.237z" />
    </svg>
  );
};

const IconNextjs = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 1024 1024';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path d="M478.5.6c-2.2.2-9.2.9-15.5 1.4C317.7 15.1 181.6 93.5 95.4 214c-48 67-78.7 143-90.3 223.5C1 465.6.5 473.9.5 512s.5 46.4 4.6 74.5C32.9 778.6 169.6 940 355 999.8c33.2 10.7 68.2 18 108 22.4 15.5 1.7 82.5 1.7 98 0 68.7-7.6 126.9-24.6 184.3-53.9 8.8-4.5 10.5-5.7 9.3-6.7-.8-.6-38.3-50.9-83.3-111.7l-81.8-110.5L487 587.7c-56.4-83.4-102.8-151.6-103.2-151.6-.4-.1-.8 67.3-1 149.6-.3 144.1-.4 149.9-2.2 153.3-2.6 4.9-4.6 6.9-8.8 9.1-3.2 1.6-6 1.9-21.1 1.9h-17.3l-4.6-2.9c-3-1.9-5.2-4.4-6.7-7.3l-2.1-4.5.2-200.5.3-200.6 3.1-3.9c1.6-2.1 5-4.8 7.4-6.1 4.1-2 5.7-2.2 23-2.2 20.4 0 23.8.8 29.1 6.6 1.5 1.6 57 85.2 123.4 185.9s157.2 238.2 201.8 305.7l81 122.7 4.1-2.7c36.3-23.6 74.7-57.2 105.1-92.2 64.7-74.3 106.4-164.9 120.4-261.5 4.1-28.1 4.6-36.4 4.6-74.5s-.5-46.4-4.6-74.5C991.1 245.4 854.4 84 669 24.2 636.3 13.6 601.5 6.3 562.5 1.9c-9.6-1-75.7-2.1-84-1.3zM687.9 310c4.8 2.4 8.7 7 10.1 11.8.8 2.6 1 58.2.8 183.5l-.3 179.8-31.7-48.6-31.8-48.6V457.2c0-84.5.4-132 1-134.3 1.6-5.6 5.1-10 9.9-12.6 4.1-2.1 5.6-2.3 21.3-2.3 14.8 0 17.4.2 20.7 2z" />
      <path d="M784.3 945.1c-3.5 2.2-4.6 3.7-1.5 2 2.2-1.3 5.8-4 5.2-4.1-.3 0-2 1-3.7 2.1zM777.4 949.6c-1.8 1.4-1.8 1.5.4.4 1.2-.6 2.2-1.3 2.2-1.5 0-.8-.5-.6-2.6 1.1zM772.4 952.6c-1.8 1.4-1.8 1.5.4.4 1.2-.6 2.2-1.3 2.2-1.5 0-.8-.5-.6-2.6 1.1zM767.4 955.6c-1.8 1.4-1.8 1.5.4.4 1.2-.6 2.2-1.3 2.2-1.5 0-.8-.5-.6-2.6 1.1zM759.8 959.6c-3.8 2-3.6 2.8.2.9 1.7-.9 3-1.8 3-2 0-.7-.1-.6-3.2 1.1z" />
    </svg>
  );
};

const IconNodejs = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 128 128';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path fill="#83CD29" d="M112.771 30.334L68.674 4.729c-2.781-1.584-6.402-1.584-9.205 0L14.901 30.334C12.031 31.985 10 35.088 10 38.407v51.142c0 3.319 2.084 6.423 4.954 8.083l11.775 6.688c5.628 2.772 7.617 2.772 10.178 2.772 8.333 0 13.093-5.039 13.093-13.828v-50.49c0-.713-.371-1.774-1.071-1.774h-5.623C42.594 41 41 42.061 41 42.773v50.49c0 3.896-3.524 7.773-10.11 4.48L18.723 90.73c-.424-.23-.723-.693-.723-1.181V38.407c0-.482.555-.966.982-1.213l44.424-25.561c.415-.235 1.025-.235 1.439 0l43.882 25.555c.42.253.272.722.272 1.219v51.142c0 .488.183.963-.232 1.198l-44.086 25.576c-.378.227-.847.227-1.261 0l-11.307-6.749c-.341-.198-.746-.269-1.073-.086-3.146 1.783-3.726 2.02-6.677 3.043-.726.253-1.797.692.41 1.929l14.798 8.754a9.294 9.294 0 004.647 1.246c1.642 0 3.25-.426 4.667-1.246l43.885-25.582c2.87-1.672 4.23-4.764 4.23-8.083V38.407c0-3.319-1.36-6.414-4.229-8.073zM77.91 81.445c-11.726 0-14.309-3.235-15.17-9.066-.1-.628-.633-1.379-1.272-1.379h-5.731c-.709 0-1.279.86-1.279 1.566 0 7.466 4.059 16.512 23.453 16.512 14.039 0 22.088-5.455 22.088-15.109 0-9.572-6.467-12.084-20.082-13.886-13.762-1.819-15.16-2.738-15.16-5.962 0-2.658 1.184-6.203 11.374-6.203 9.105 0 12.461 1.954 13.842 8.091.118.577.645.991 1.24.991h5.754c.354 0 .692-.143.94-.396.24-.272.367-.613.335-.979-.891-10.568-7.912-15.493-22.112-15.493-12.631 0-20.166 5.334-20.166 14.275 0 9.698 7.497 12.378 19.622 13.577 14.505 1.422 15.633 3.542 15.633 6.395 0 4.955-3.978 7.066-13.309 7.066z" />
    </svg>
  );
};

const IconQueue = ({
  className,
  style,
  spin,
  rotate,
  onClick,
}: IconProps): React.ReactElement => {
  const icon = 'IconQueue';
  return (
    <IconTemplate
      className={className}
      style={style}
      spin={spin}
      rotate={rotate}
      onClick={onClick}
      iconName={icon}
    />
  );
};

const IconReact = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 128 128';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <g fill="#61DAFB">
        <circle cx="64" cy="64" r="11.4" />
        <path d="M107.3 45.2c-2.2-.8-4.5-1.6-6.9-2.3.6-2.4 1.1-4.8 1.5-7.1 2.1-13.2-.2-22.5-6.6-26.1-1.9-1.1-4-1.6-6.4-1.6-7 0-15.9 5.2-24.9 13.9-9-8.7-17.9-13.9-24.9-13.9-2.4 0-4.5.5-6.4 1.6-6.4 3.7-8.7 13-6.6 26.1.4 2.3.9 4.7 1.5 7.1-2.4.7-4.7 1.4-6.9 2.3C8.2 50 1.4 56.6 1.4 64s6.9 14 19.3 18.8c2.2.8 4.5 1.6 6.9 2.3-.6 2.4-1.1 4.8-1.5 7.1-2.1 13.2.2 22.5 6.6 26.1 1.9 1.1 4 1.6 6.4 1.6 7.1 0 16-5.2 24.9-13.9 9 8.7 17.9 13.9 24.9 13.9 2.4 0 4.5-.5 6.4-1.6 6.4-3.7 8.7-13 6.6-26.1-.4-2.3-.9-4.7-1.5-7.1 2.4-.7 4.7-1.4 6.9-2.3 12.5-4.8 19.3-11.4 19.3-18.8s-6.8-14-19.3-18.8zM92.5 14.7c4.1 2.4 5.5 9.8 3.8 20.3-.3 2.1-.8 4.3-1.4 6.6-5.2-1.2-10.7-2-16.5-2.5-3.4-4.8-6.9-9.1-10.4-13 7.4-7.3 14.9-12.3 21-12.3 1.3 0 2.5.3 3.5.9zM81.3 74c-1.8 3.2-3.9 6.4-6.1 9.6-3.7.3-7.4.4-11.2.4-3.9 0-7.6-.1-11.2-.4-2.2-3.2-4.2-6.4-6-9.6-1.9-3.3-3.7-6.7-5.3-10 1.6-3.3 3.4-6.7 5.3-10 1.8-3.2 3.9-6.4 6.1-9.6 3.7-.3 7.4-.4 11.2-.4 3.9 0 7.6.1 11.2.4 2.2 3.2 4.2 6.4 6 9.6 1.9 3.3 3.7 6.7 5.3 10-1.7 3.3-3.4 6.6-5.3 10zm8.3-3.3c1.5 3.5 2.7 6.9 3.8 10.3-3.4.8-7 1.4-10.8 1.9 1.2-1.9 2.5-3.9 3.6-6 1.2-2.1 2.3-4.2 3.4-6.2zM64 97.8c-2.4-2.6-4.7-5.4-6.9-8.3 2.3.1 4.6.2 6.9.2 2.3 0 4.6-.1 6.9-.2-2.2 2.9-4.5 5.7-6.9 8.3zm-18.6-15c-3.8-.5-7.4-1.1-10.8-1.9 1.1-3.3 2.3-6.8 3.8-10.3 1.1 2 2.2 4.1 3.4 6.1 1.2 2.2 2.4 4.1 3.6 6.1zm-7-25.5c-1.5-3.5-2.7-6.9-3.8-10.3 3.4-.8 7-1.4 10.8-1.9-1.2 1.9-2.5 3.9-3.6 6-1.2 2.1-2.3 4.2-3.4 6.2zM64 30.2c2.4 2.6 4.7 5.4 6.9 8.3-2.3-.1-4.6-.2-6.9-.2-2.3 0-4.6.1-6.9.2 2.2-2.9 4.5-5.7 6.9-8.3zm22.2 21l-3.6-6c3.8.5 7.4 1.1 10.8 1.9-1.1 3.3-2.3 6.8-3.8 10.3-1.1-2.1-2.2-4.2-3.4-6.2zM31.7 35c-1.7-10.5-.3-17.9 3.8-20.3 1-.6 2.2-.9 3.5-.9 6 0 13.5 4.9 21 12.3-3.5 3.8-7 8.2-10.4 13-5.8.5-11.3 1.4-16.5 2.5-.6-2.3-1-4.5-1.4-6.6zM7 64c0-4.7 5.7-9.7 15.7-13.4 2-.8 4.2-1.5 6.4-2.1 1.6 5 3.6 10.3 6 15.6-2.4 5.3-4.5 10.5-6 15.5C15.3 75.6 7 69.6 7 64zm28.5 49.3c-4.1-2.4-5.5-9.8-3.8-20.3.3-2.1.8-4.3 1.4-6.6 5.2 1.2 10.7 2 16.5 2.5 3.4 4.8 6.9 9.1 10.4 13-7.4 7.3-14.9 12.3-21 12.3-1.3 0-2.5-.3-3.5-.9zM96.3 93c1.7 10.5.3 17.9-3.8 20.3-1 .6-2.2.9-3.5.9-6 0-13.5-4.9-21-12.3 3.5-3.8 7-8.2 10.4-13 5.8-.5 11.3-1.4 16.5-2.5.6 2.3 1 4.5 1.4 6.6zm9-15.6c-2 .8-4.2 1.5-6.4 2.1-1.6-5-3.6-10.3-6-15.6 2.4-5.3 4.5-10.5 6-15.5 13.8 4 22.1 10 22.1 15.6 0 4.7-5.8 9.7-15.7 13.4z" />
      </g>
    </svg>
  );
};

const IconSass = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 547.8 410.6';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <path fill="#CD6799" d="M471.4 236c-19.1.1-35.7 4.7-49.6 11.5-5.1-10.1-10.2-19.1-11.1-25.7-1-7.7-2.2-12.4-1-21.6 1.2-9.2 6.6-22.3 6.5-23.3s-1.2-5.7-12.2-5.8c-11-.1-20.5 2.1-21.6 5-1.1 2.9-3.2 9.5-4.6 16.3-1.9 10-22 45.7-33.5 64.4-3.7-7.3-6.9-13.7-7.6-18.8-1-7.7-2.2-12.4-1-21.6 1.2-9.2 6.6-22.3 6.5-23.3-.1-1-1.2-5.7-12.2-5.8-11-.1-20.5 2.1-21.6 5-1.1 2.9-2.3 9.7-4.6 16.3-2.3 6.6-29 66.2-36 81.6-3.6 7.9-6.7 14.2-8.9 18.5s-.1.3-.4.8c-1.9 3.7-3 5.7-3 5.7v.1c-1.5 2.7-3.1 5.2-3.9 5.2-.6 0-1.7-7.2.2-17 4-20.7 13.5-52.9 13.4-54 0-.6 1.8-6.2-6.2-9.1-7.8-2.9-10.6 1.9-11.3 1.9-.7 0-1.2 1.7-1.2 1.7s8.7-36.2-16.6-36.2c-15.8 0-37.6 17.3-48.4 32.9-6.8 3.7-21.3 11.6-36.8 20.1-5.9 3.3-12 6.6-17.7 9.7-.4-.4-.8-.9-1.2-1.3-30.6-32.7-87.2-55.8-84.8-99.7.9-16 6.4-58 108.7-109 84.2-41.5 151.2-30 162.8-4.5 16.6 36.4-35.9 104-122.9 113.8-33.2 3.7-50.6-9.1-55-13.9-4.6-5-5.3-5.3-7-4.3-2.8 1.5-1 6 0 8.6 2.6 6.8 13.3 18.8 31.4 24.7 16 5.2 54.9 8.1 102-10.1 52.7-20.4 93.9-77.1 81.8-124.6C330.7 2 250.7-13.9 175 13 130 29 81.2 54.2 46.1 87 4.4 126-2.2 159.9.5 174.1c9.7 50.4 79.2 83.2 107 107.5-1.4.8-2.7 1.5-3.8 2.1-13.9 6.9-66.9 34.6-80.1 63.9-15 33.2 2.4 57 13.9 60.2 35.7 9.9 72.4-7.9 92.1-37.3 19.7-29.4 17.3-67.6 8.2-85.1-.1-.2-.2-.4-.4-.6 3.6-2.1 7.3-4.3 10.9-6.4 7.1-4.2 14.1-8.1 20.1-11.3-3.4 9.3-5.9 20.4-7.1 36.4-1.5 18.8 6.2 43.2 16.3 52.8 4.5 4.2 9.8 4.3 13.2 4.3 11.8 0 17.1-9.8 23-21.4 7.2-14.2 13.7-30.7 13.7-30.7s-8.1 44.6 13.9 44.6c8 0 16.1-10.4 19.7-15.7v.1s.2-.3.6-1c.8-1.3 1.3-2.1 1.3-2.1v-.2c3.2-5.6 10.4-18.3 21.1-39.4 13.8-27.2 27.1-61.2 27.1-61.2s1.2 8.3 5.3 22.1c2.4 8.1 7.4 17 11.4 25.6-3.2 4.5-5.2 7-5.2 7l.1.1c-2.6 3.4-5.4 7.1-8.5 10.7-10.9 13-23.9 27.9-25.7 32.2-2.1 5.1-1.6 8.8 2.4 11.8 2.9 2.2 8.1 2.5 13.4 2.2 9.8-.7 16.7-3.1 20.1-4.6 5.3-1.9 11.5-4.8 17.3-9.1 10.7-7.9 17.2-19.2 16.6-34.1-.3-8.2-3-16.4-6.3-24.1 1-1.4 1.9-2.8 2.9-4.2 16.9-24.7 30-51.8 30-51.8s1.2 8.3 5.3 22.1c2 7 6.1 14.6 9.7 22-15.9 12.9-25.7 27.9-29.2 37.7-6.3 18.2-1.4 26.4 7.9 28.3 4.2.9 10.2-1.1 14.6-3 5.6-1.8 12.2-4.9 18.5-9.5 10.7-7.9 21-18.9 20.4-33.8-.3-6.8-2.1-13.5-4.6-20 13.5-5.6 30.9-8.7 53.1-6.1 47.6 5.6 57 35.3 55.2 47.8-1.8 12.5-11.8 19.3-15.1 21.4-3.3 2.1-4.4 2.8-4.1 4.3.4 2.2 2 2.1 4.8 1.7 3.9-.7 25-10.1 25.9-33.1 1.5-29.4-26.5-61.5-76-61.2zM104.2 359.8C88.4 377 66.4 383.5 56.9 378c-10.2-5.9-6.2-31.3 13.2-49.5 11.8-11.1 27-21.4 37.1-27.7 2.3-1.4 5.7-3.4 9.8-5.9.7-.4 1.1-.6 1.1-.6l2.4-1.5c7.1 26 .3 48.9-16.3 67zm115-78.2c-5.5 13.4-17 47.7-24 45.8-6-1.6-9.7-27.6-1.2-53.3 4.3-12.9 13.4-28.3 18.7-34.3 8.6-9.6 18.1-12.8 20.4-8.9 2.9 5.1-10.5 42.3-13.9 50.7zm94.9 45.4c-2.3 1.2-4.5 2-5.5 1.4-.7-.4 1-2 1-2s11.9-12.8 16.6-18.6c2.7-3.4 5.9-7.4 9.3-11.9v1.3c0 15.3-14.8 25.6-21.4 29.8zm73.2-16.7c-1.7-1.2-1.4-5.2 4.3-17.7 2.2-4.9 7.4-13.1 16.3-21 1 3.2 1.7 6.3 1.6 9.2-.1 19.3-13.9 26.5-22.2 29.5z" />
    </svg>
  );
};

const IconTypescript = ({
  className,
  style,
  spin,
  onClick,
}: IconProps): React.ReactElement => {
  const viewBox = '0 0 512 512';
  return (
    <svg
      viewBox={viewBox}
      focusable="false"
      className={`jth-icon${className ? ` ${className}` : ``}${spin ? ' spin' : ``
        }`}
      style={style}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      onClick={onClick}
    >
      <rect width="512" height="512" fill="#3178c6" rx="50" />
      <rect width="512" height="512" fill="#3178c6" rx="50" />
      <path fill="#fff" d="M316.939 407.424v50.061c8.138 4.172 17.763 7.3 28.875 9.386S368.637 470 380.949 470c11.999 0 23.397-1.147 34.196-3.442 10.799-2.294 20.268-6.075 28.406-11.342 8.138-5.266 14.581-12.15 19.328-20.65S470 415.559 470 403.044c0-9.074-1.356-17.026-4.069-23.857s-6.625-12.906-11.738-18.225c-5.112-5.319-11.242-10.091-18.389-14.315s-15.207-8.213-24.18-11.967c-6.573-2.712-12.468-5.345-17.685-7.9-5.217-2.556-9.651-5.163-13.303-7.822-3.652-2.66-6.469-5.476-8.451-8.448-1.982-2.973-2.974-6.336-2.974-10.091 0-3.441.887-6.544 2.661-9.308s4.278-5.136 7.512-7.118c3.235-1.981 7.199-3.52 11.894-4.615 4.696-1.095 9.912-1.642 15.651-1.642 4.173 0 8.581.313 13.224.938 4.643.626 9.312 1.591 14.008 2.894a97.514 97.514 0 0113.694 4.928c4.434 1.982 8.529 4.276 12.285 6.884v-46.776c-7.616-2.92-15.937-5.084-24.962-6.492S415.797 238 404.112 238c-11.895 0-23.163 1.278-33.805 3.833s-20.006 6.544-28.093 11.967c-8.086 5.424-14.476 12.333-19.171 20.729-4.695 8.395-7.043 18.433-7.043 30.114 0 14.914 4.304 27.638 12.912 38.172 8.607 10.533 21.675 19.45 39.204 26.751 6.886 2.816 13.303 5.579 19.25 8.291s11.086 5.528 15.415 8.448c4.33 2.92 7.747 6.101 10.252 9.543 2.504 3.441 3.756 7.352 3.756 11.733 0 3.233-.783 6.231-2.348 8.995s-3.939 5.162-7.121 7.196-7.147 3.624-11.894 4.771c-4.748 1.148-10.303 1.721-16.668 1.721-10.851 0-21.597-1.903-32.24-5.71-10.642-3.806-20.502-9.516-29.579-17.13zM232.78 284.082H297V243H118v41.082h63.906V467h50.874z" />
    </svg>
  );
};

export {
  IconTemplate,
  IconAngleDown,
  IconArrowToTop,
  IconBars,
  IconCommentDots,
  IconCombination,
  IconEnvelope,
  IconEye,
  IconEyeSlash,
  IconGCD,
  IconGithub,
  IconHome,
  IconLaptopCode,
  IconLCM,
  IconLink,
  IconLinkedIn,
  IconObjectGroup,
  IconPermutation,
  IconPlay,
  IconSearch,
  IconSearchPlus,
  IconSieve,
  IconSpinner,
  IconTimes,
  IconTimesCircle,
  IconUser,
  IconUserTie,
  IconLogo,
  IconLogoColored,
  IconAWS,
  IconCSS3,
  IconFigma,
  IconGatsby,
  IconGraphql,
  IconHtml5,
  IconJavascript,
  IconNextjs,
  IconNodejs,
  IconReact,
  IconSass,
  IconTypescript
};
